import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  ProcessStep,
  getSurveyProcess,
  sendActionPlanReminder,
  sendActionPlanSummary,
  sendSurveyReminder,
} from '../../../api/surveyProcess';
import { isPreparingSummary } from '../../../pages/TeamDashboard/processView';

export const SurveyProcessQueryKey = 'SURVEY_PROCESS';

/**
 * Asked again every minute, so a reminder or an answer shows up without reloading. While the summary is being written,
 * it is asked more often, so the team leader sees it go out.
 */
export const useSurveyProcessQuery = (teamId: number) =>
  useQuery({
    queryKey: [SurveyProcessQueryKey, teamId],
    queryFn: () => getSurveyProcess(teamId),
    refetchInterval: (query) => (isPreparingSummary(query.state.data) ? 5_000 : 60_000),
    enabled: Boolean(teamId),
  });

/** The reminder of the step the team is in. The process is asked again afterwards, so the card shows it on its way */
export const useSendReminderMutation = (teamId: number, step: ProcessStep) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => (step === 'ACTION_PLAN' ? sendActionPlanReminder(teamId) : sendSurveyReminder(teamId)),
    onSettled: () => queryClient.invalidateQueries({ queryKey: [SurveyProcessQueryKey, teamId] }),
  });
};

export const useSendActionPlanSummaryMutation = (teamId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => sendActionPlanSummary(teamId),
    onSettled: () => queryClient.invalidateQueries({ queryKey: [SurveyProcessQueryKey, teamId] }),
  });
};
